<template>
  <v-card class="rounded-lg white">
    <v-card-title class="secondary--text">
      <v-img class="ml-2" max-height="25" max-width="25" src="/img/icons/factor.svg"></v-img>
      {{ title }}
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-autocomplete
          label="وضعیت تراکنش"
          class="rounded-lg"
          :return-object="false"
          :items="paid_types"
          v-model="filters.is_paid"
          item-text="name"
          item-value="value"
          clearable
        />
      </v-col>
      <v-btn color="primary" class="ml-2" @click="dialogCreate = true">
        ایجاد فاکتور 
      </v-btn>
    </v-card-title>
    <v-card-text>
      <m-datatable
        :headers="headers"
        :apiUrl="url"
        :filters.sync="filters"
        ref="datatable"
        @click:row="handleRowClick"
      >

      <template #item.items="{ item }">
        <div v-for="row in item.items">
          {{ row.type }} بسته {{ row.extension}}
        </div>
      </template>
    </m-datatable>
    </v-card-text>

    <v-dialog v-model="dialog" :overlay="true" transition="dialog-transition">
      <user-detail v-if="userId" :id="userId" />
    </v-dialog>
    <v-dialog
      v-model="dialogCreate"
      max-width="900px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card class="pt-5">
        <v-card-text>
          <factor-create />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment-jalaali";
import UserDetail from "@/components/users/UserDetail.vue";
import FactorCreate from "@/components/factors/FactorCreate.vue";

export default {
  name: "FactorsList",
  components: { UserDetail, FactorCreate },
  data() {
    return {
      paid_types: [
        { name: "همه ی تراکنش ها", value: null },
        { name: "تراکنش های موفق", value: true },
        { name: "تراکنش های ناموفق", value: false },
      ],
      filters: {
        is_paid: true,
        company: this.id,
      },
      dialogCreate: false,
      userId: null,
      dialog: false,
    };
  },
  props: {
    id: {},
  },
  computed: {
    url() {
      return "sobhanAdmin/factors";
    },
    title() {
      if (this.id) return "سابقه تراکنش های شرکت";
      return "لیست تراکنش ها";
    },
    headers() {
      let headers = [
        {
          text: "تاریخ",
          value: "date",
          type: "date",
          getValue: (item) => {
            return item.created_at.split(" ")[0];
          },
        },
        {
          text: "ساعت",
          value: "time",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[1];
          },
        },
        {
          text: "نام کاربری",
          value: "username",
        },
        {
          text: "شرکت",
          value: "company_name",
        },
        {
          text: "شناسه یکتا",
          value: "id",
        },
        {
          text: "مبلغ",
          value: "amount",
          type: "numeric",
        },
        {
          text: "تخفیف",
          value: "discount_amount",
          type: "numeric",
        },
        {
          text: "مبلغ قابل پرداخت",
          value: "payable_amount",
          type: "numeric",
        },
        {
          text: "وضعیت پرداخت",
          value: "is_paid",
          type: "boolean",
          filterable: false,
          sortable: false,

        },
        {
          text: "بازه",
          value: "billing_cycle",
          type: "select",
          items: [
            {
              'text': 'ماهانه',
              'value': 'monthly'
            },
            {
              'text': 'سالانه',
              'value': 'yearly'
            },
            {
              'text': 'شش ماهه',
              'value': 'six_monthly'
            },
            {
              'text': 'دائمی',
              'value': 'permanent'
            },
          ]
        },
        {
          text: 'توضیحات', 
          value: 'items',
          filterable: false,
          sortable: false,
        }
      ];

      return headers;
    },
  },
  methods: {
    format_date(value) {
      return moment(value).format("YYYY/MM/DD");
    },
    format_time(value) {
      return moment(value).format("HH:mm");
    },
    handleRowClick(row) {
      this.userId = row.user;
      this.dialog = true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
